/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EventState {
    Planned = 0,
    Active = 1,
    Inactive = 2,
    Archived = 3,
    Draft = 4,
}
